module.exports = __webpack_public_path__ + "img/3_197.fd3db95b.png";